import React from 'react';

const ProductNotFound = () => {
    return (
       <div className="archive">
            <div className="inner notfound">
                <h2>Nic jsme nenašli</h2>
                
                <p>Zkuste vyhledat něco jiného, nebo si otevřete <a href="/product/">celou nabídku.</a></p>
             
                {
                    <div className="img">
                		<img src="/img_svg/hledani_nic-nenalezeno.svg" alt=""/>
					</div>
            	}
            </div>
      </div>

    );
  };
  
  export default ProductNotFound;